import { computeGradingTalkRatio } from "@repo/app-types/helpers/gradingAssessmentHelpers";
import type { Size } from "@repo/ui/helpers/helpers";
import type { FC } from "react";
import { GradingTalkRatioPill } from "./gradingTalkRatioPill.js";

export interface GradingTalkRatioProps {
  size: Size;
  speakerMs: number | undefined;
  totalSpeechMs: number | undefined;
  isLoading?: boolean;
}

export const GradingTalkRatio: FC<GradingTalkRatioProps> = (props) => {
  const { speakerMs, totalSpeechMs } = props;

  const talkRatio = computeGradingTalkRatio(speakerMs, totalSpeechMs);

  return (
    <span className="inline-flex items-baseline gap-2">
      <GradingTalkRatioPill
        size={props.size}
        talkRatio={talkRatio}
        // Don't show a loading state if values were provided but the denominator was zero
        isLoading={props.isLoading && totalSpeechMs !== 0}
      />
    </span>
  );
};
